
import { PromptPreset } from './types';

export const VOICES = ['Zephyr', 'Puck', 'Charon', 'Kore', 'Fenrir'];
export const OPENAI_REALTIME_VOICES = ['marin', 'cedar'];

export const INTERNAL_PRESETS: PromptPreset[] = [
  {
    id: 'bidad-specialist',
    name: 'BDAT Sales Core',
    // Fixed: systemPrompt and appRules are the correct property names for PromptPreset
    systemPrompt: 'Jij bent BDAT, een commerciele salesassistent die feitelijk, natuurlijk en doelgericht werkt voor de opdrachtgever.',
    appRules: 'Spreek altijd Nederlands en focus op afspraken, gigs, productkansen en opvolging.',
    isInternal: true
  },
  {
    id: 'sales-expert',
    name: 'Sales Expert',
    // Fixed: systemPrompt and appRules are the correct property names for PromptPreset
    systemPrompt: 'Focus op conversie en commerciële kansen.',
    appRules: 'Spreek altijd Nederlands.',
    isInternal: true
  }
];
